import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const CheckBox = (props) => {
    const classNames = classnames('checkbox', {
        'checkbox--isSelected': props.isSelected
    });

    return (
        <div className={classNames} onClick={props.onClick} role="checkbox" aria-checked={props.isSelected} tabIndex="0">
            <div className="checkbox__box"></div>
            <label>{props.label}</label>
        </div>
    );
};

CheckBox.propTypes = {
    isSelected: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    label: PropTypes.node
};

export default CheckBox;